import styles from './styles.module.scss'

const PleaseWait = () => (
    <div className={styles.pleaseWait}>
        <h3>Please wait..</h3>
    </div>
)

export default PleaseWait
